import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getPurchases = async userId => {
  const { data: orders, error: orderError } = await supabase
    .from('orders')
    .select('id, status, transactions(external_id)')
    .eq('created_by', userId)
    .neq('status', 'Pending');

  if (orderError) {
    throw new Error(`Error fetching orders: ${orderError.message}`);
  }

  if (!orders || orders.length === 0) {
    return [];
  }

  const orderMap = orders.reduce((acc, order) => {
    acc[order.id] = {
      status: order.status,
      //@ts-ignore
      external_id: order.transactions?.external_id || null, // Предполагаем, что transactions — это массив
    };
    return acc;
  }, {});

  const orderIds = Object.keys(orderMap);

  const { data: orderItems, error: orderItemsError } = await supabase
    .from('order_items')
    .select(
      `
            *,
            gift_cards(*),
            product(*), 
            service(*, service_pricing_duration(*)),
            orders!inner(status)
        `,
    )
    .in('order_id', orderIds)
    .order('created_at', { ascending: false });

  if (orderItemsError) {
    throw new Error(`Error fetching order items: ${orderItemsError.message}`);
  }

  const orderItemsWithStatus = orderItems.map(item => ({
    ...item,
    status: orderMap[item.order_id]?.status || 'Unknown',
    external_id: orderMap[item.order_id]?.external_id || null, // Добавляем external_id
  }));

  return orderItemsWithStatus;
};

export default function useGetPruchases(userId) {
  return useQuery({
    queryKey: ['useGetPruchases', userId],
    queryFn: () => getPurchases(userId),
    staleTime: 0,
    enabled: !!userId,
  });
}
